/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
// import anime from "animejs/lib/anime.es.js";
const swiperCardInfo = new Swiper(
	".sc-cards-info__cards-container__swiper-container",
	{
		slidesPerView: 1.12,
		spaceBetween: 12,
		rewind: false,
		speed: 500,
		breakpoints: {
			501: {
				slidesPerView: 1.2,
				spaceBetween: 12,
			},
			600: {
				slidesPerView: 1.35,
				spaceBetween: 16,
			},
			// 1024: {
			// 	slidesPerView: 3,
			// },
			835: {
				slidesPerView: 2,
				spaceBetween: 16,
			},
		},
	},
);

const syncCardsHeight = () => {
	const containers = document.querySelectorAll(
		".sc-cards-info__cards-container",
	);

	containers.forEach((container) => {
		const visibleCards = Array.from(container.querySelectorAll(".card")).filter(
			(card) => card.offsetParent !== null,
		);

		visibleCards.forEach((card) => {
			card.style.minHeight = "";
		});

		const maxHeight = visibleCards.reduce(
			(height, card) => Math.max(height, card.getBoundingClientRect().height),
			0,
		);

		if (maxHeight > 0) {
			visibleCards.forEach((card) => {
				card.style.minHeight = `${Math.ceil(maxHeight)}px`;
			});
		}
	});
};

let resizeTimeout;
const syncCardsHeightOnResize = () => {
	clearTimeout(resizeTimeout);
	resizeTimeout = setTimeout(syncCardsHeight, 120);
};

window.addEventListener("load", syncCardsHeight);
window.addEventListener("resize", syncCardsHeightOnResize);

if (swiperCardInfo) {
	swiperCardInfo.on("init", syncCardsHeight);
	swiperCardInfo.on("resize", syncCardsHeight);
	swiperCardInfo.on("breakpoint", syncCardsHeight);
	swiperCardInfo.on("slideChangeTransitionEnd", syncCardsHeight);
}

const cards = document.querySelectorAll(
	".sc-cards-info__cards-container .card",
);

let options = {
	root: null,
	rootMargin: "0px",
	threshold: 0.0,
};

const handleCardWatcherEntry = (entries, observer) => {
	entries.forEach((element) => {
		if (element.isIntersecting) {
			animatedCard(element.target);
			observer.unobserve(element.target);
		}
	});
};

const intersectionWatcher = () => {
	let observerCard = new IntersectionObserver(handleCardWatcherEntry, options);
	cards.forEach((card) => {
		observerCard.observe(card);
	});
};

intersectionWatcher();

const animatedCard = (card) => {
	anime({
		targets: card,
		opacity: [0, 1],
		duration: 300,
		easing: "easeOutExpo",
		delay: 500,
	});
};

const getDeviceInfo = () => {
	const ua = navigator.userAgent;
	const isTouchDevice =
		"ontouchstart" in window || navigator.maxTouchPoints > 0;
	const hasCoarsePointer = window.matchMedia("(pointer: coarse)").matches;
	const screenWidth = window.screen.width;

	let devicetype = "Desktop";
	if (
		/(tablet|ipad)/i.test(ua) ||
		(isTouchDevice && screenWidth >= 768 && screenWidth <= 1024)
	) {
		devicetype = "Tablet";
	} else if (
		/(mobile|android|iphone|ipod|blackberry|iemobile|opera mini)/i.test(ua) ||
		hasCoarsePointer
	) {
		devicetype = "Mobile";
	}
	let os = "Unknown OS";

	if (/Win/i.test(ua)) {
		os = "Windows";
	} else if (/Mac/i.test(ua)) {
		os = "Mac OS";
	} else if (/Linux/i.test(ua)) {
		os = "Linux";
	} else if (/Android/i.test(ua)) {
		os = "Android";
	} else if (/iPhone|iPad|iPod/i.test(ua)) {
		os = "iOS";
	}

	return { devicetype, os };
};

let cardDownload = document.querySelector(".download");
window.addEventListener("DOMContentLoaded", () => {
	syncCardsHeight();
	if (cardDownload) {
		cardDownload.childNodes[0].addEventListener("click", () => {
			const { devicetype, os } = getDeviceInfo();

			dataLayer.push({
				event: "clic_modal_app_personas",
				name: "clic modal app personas",
				page: window.location.pathname,
				device_category: devicetype,
				operative_system: os,
			});
			console.log("Send: clic modal app personas");
		});
		console.log(cardDownload.childNodes[0]);
	}
});
